export const ExecutiveReasonReviewNameFields = {
	reasonForReview: "reason_for_review",
	requestingTheFollowing: "requesting_the_following",
	nextReviewDate: "next_review_date",
};

export const ExecutiveSignerNameFields = {
	signerOne: "signer_one",
	signerTwo: "signer_two",
	signerThree: "signer_three",
	signerFour: "signer_four",
	firstName: "first_name",
	lastName: "last_name",
	ownership: "ownership",
	ficoScore: "fico_score",
	comment: "comment",
	signerNumber: "signer_number",
};

export const ExecutiveApprovedParametersNameFields = {
	monthlyVolume: "monthly_volume",
	maxTicket: "max_ticket",
	avgTicket: "avg_ticket",
};

export const ExecutiveEstimatedExposureNameFields = {
	deliverySameDay: "deliverySameDay",
	deliveryFromOneToThreeDays: "deliveryFromOneToThreeDays",
	deliveryFromFourToSevenDays: "deliveryFromFourToSevenDays",
	deliveryFromEightToFourteenDays: "deliveryFromEightToFourteenDays",
	deliveryFromFifteenToThirtyDays: "deliveryFromFifteenToThirtyDays",
	deliveryOverThirtyDays: "deliveryOverThirtyDays",
	futureDeliveryExposure: "futureDeliveryExposure",
	totalCreditExposure: "totalCreditExposure",
};

export const ExecutiveRecommendationNameFields = {
	recommendation: "recommendation",
};

export const ExecutiveBusinessReviewNameFields = {
	businessMessage: "businessReviewMessage",
};

export const ExecutiveProductReviewNameFields = {
	website: "productReviewWebsite",
	comment: "comments",
};

export const ExecutiveFinancialsFormFields = {
	balanceDate: "balance_sheet_date",
	balanceCash: "cash",
	balanceOtherCurrentAssets: "other_current_assets",
	balanceTotalCurrentAssets: "total_current_assets",
	balanceTotalAssets: "total_assets",
	balanceAccountsPayable: "accounts_payable",
	balanceTotalCurrentLiabilities: "total_current_liabilities",
	balanceTotalLiabilities: "total_liabilities",
	balanceShareholderEquity: "shareholder_equity",
	balanceCurrentRatio: "current_ratio",
	balanceDebtRatio: "debt_ratio",
	balanceWorkingCapital: "working_capital",
	balanceDebtToEquity: "debt_to_equity",
	plDate: "p_and_l_date",
	plTotalIncome: "total_income",
	plCOGS: "cogs",
	plGrossProfit: "gross_profit",
	plOperatingExpenses: "operating_expenses",
	plOtherIncome: "other_income_expense",
	plTotalExpenses: "total_expenses",
	plNetIncome: "net_income",
	deferredRevenue: "deferred_revenue",
};

export const ExecutiveProcessingReviewFields = {
	AverageTicket: {
		name: "averageTicket",
		displayName: "Average Ticket, $",
		beName: "average_ticket",
	},
	ChargebackTransactionsPercent: {
		name: "chargebackTransactionsPercent",
		displayName: "% Trans",
		beName: "chargeback_transactions_percent",
	},
	ChargebacksAmount: {
		name: "chargebacksAmount",
		displayName: "Amount, $",
		beName: "chargebacks_amount",
	},
	ChargebacksCount: {
		name: "chargebacksCount",
		displayName: "Count",
		beName: "chargebacks_count",
	},
	ChargebacksVolume: {
		name: "chargebacksVolume",
		displayName: "% Vol",
		beName: "chargebacks_volume",
	},
	CreditTransactionsPercent: {
		name: "creditTransactionsPercent",
		displayName: "% Trans",
		beName: "credit_transactions_percent",
	},
	CreditsAmount: {
		name: "creditsAmount",
		displayName: "Amount, $",
		beName: "credits_amount",
	},
	CreditsAmountVolume: {
		name: "creditsAmountVolume",
		displayName: "% Vol",
		beName: "credits_amount_volume",
	},
	CreditsCount: {
		name: "creditsCount",
		displayName: "Count",
		beName: "credits_count",
	},
	LargestSaleAmount: {
		name: "largestSaleAmount",
		displayName: "Largest Sale Amount, $",
		beName: "largest_sale_amount",
	},
	ProcessingMonth: {
		name: "processingMonth",
		displayName: "Date",
		beName: "processing_month",
	},
	SalesAmount: {
		name: "salesAmount",
		displayName: "Amount, $",
		beName: "sales_amount",
	},
	SalesCount: {
		name: "salesCount",
		displayName: "Count",
		beName: "sales_count",
	},
};
